import { useEffect, useRef } from "react";

import type { LayersList } from "@deck.gl/core";

import { useDeckOverlays } from "./DeckOverlaysContext";
import type { DeckSlot } from "./DeckSlot";

const useDeckLayers = (slot: DeckSlot, layers: LayersList) => {
  const { removeLayers, setLayers } = useDeckOverlays();
  const keyRef = useRef(Symbol("deckLayers"));

  useEffect(() => {
    setLayers(slot, keyRef.current, layers);
  }, [layers, setLayers, slot]);

  useEffect(() => {
    const key = keyRef.current;
    return () => removeLayers(slot, key);
  }, [removeLayers, slot]);
};

export default useDeckLayers;
